import { Subject } from 'rxjs';

export class MenuService {
  forceIndexSubject = new Subject<number>();

  forceActiveMenuIndex(index: number): void {
    this.forceIndexSubject.next(index);
  }
}
